"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DiContainer = (function () {
    function DiContainer() {
        this.registry = {};
    }
    DiContainer.prototype.register = function (key, dependency) {
        this.registry[key] = dependency;
        return this;
    };
    DiContainer.prototype.get = function (key) {
        var dependency = this.registry[key];
        if (!dependency) {
            throw new Error("No dependency found for symbol ".concat(key));
        }
        return dependency;
    };
    DiContainer.prototype.__clear = function () {
        this.registry = {};
    };
    return DiContainer;
}());
exports.default = new DiContainer();
//# sourceMappingURL=index.js.map